(function () {
  function initRotator(root) {
    var items = root.querySelectorAll('.announcement-bar__rotate-item');
    if (items.length < 2) return;

    var interval = parseFloat(root.getAttribute('data-interval')) || 4;
    var current = 0;

    setInterval(function () {
      items[current].classList.remove('is-active');
      current = (current + 1) % items.length;
      items[current].classList.add('is-active');
    }, interval * 1000);
  }

  document.querySelectorAll('[data-announcement-rotate]').forEach(initRotator);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-announcement-rotate]');
    if (root) initRotator(root);
  });
})();
